import {
  type AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  type OnDestroy,
  type OnInit,
  ViewChild
} from '@angular/core'
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core'
import {
  MAT_DIALOG_DATA,
  MatDialog, MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog'
import { MatStep, MatStepLabel, MatStepper, MatStepperIcon } from '@angular/material/stepper'
import {
  CptDateAdapter, SharedTranslatePipe,
  TransifexService
} from '@inside-hub-app/customer-portal-shared'
import { TranslateService } from '@ngx-translate/core'
import {
  APP_DATE_FORMATS_1,
  SharedService
} from '../../../services/shared.service'

import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import {
  AppointmentsPopupService,
  ReifenData
} from '../../../services/appointments-popup.service'
import { NgTemplateOutlet } from '@angular/common'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { MatIcon } from '@angular/material/icon'
import { AppointmentsPopupFirstFormComponent } from './appointments-popup-first-form/appointments-popup-first-form.component'
import { AppointmentsPopupSecondFormComponent } from './appointments-popup-second-form/appointments-popup-second-form.component'
import { AppointmentsPopupThirdFormComponent } from './appointments-popup-third-form/appointments-popup-third-form.component'
import { AppointmentsPopupFourthFormComponent } from './appointments-popup-fourth-form/appointments-popup-fourth-form.component'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatButton } from '@angular/material/button'
import { MatDivider } from '@angular/material/list'

@Component({
  selector: 'customer-portal-app-appointments-popup',
  standalone: true,
  templateUrl: './appointments-popup.component.html',
  imports: [
    MatIcon,
    MatDialogClose,
    MatDialogTitle,
    HubChildTranslateModule,
    MatDialogContent,
    MatStepper,
    MatStep,
    SharedTranslatePipe,
    AppointmentsPopupFirstFormComponent,
    AppointmentsPopupSecondFormComponent,
    AppointmentsPopupThirdFormComponent,
    AppointmentsPopupFourthFormComponent,
    MatStepLabel,
    MatStepperIcon,
    MatProgressSpinner,
    MatDialogActions,
    MatButton,
    MatDivider,
    NgTemplateOutlet
],
  providers: [
    AppointmentsPopupService,
    {
      provide: DateAdapter,
      useClass: CptDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS_1
    }
  ]
})
export class AppointmentsPopupComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('stepper', { static: true }) stepper: MatStepper

  constructor (
    public appointmentsPopupService: AppointmentsPopupService,
    public dialog: MatDialog,
    readonly dialogRef: MatDialogRef<AppointmentsPopupComponent>,
    public translateService: TranslateService,
    public sharedService: SharedService,
    private readonly cdf: ChangeDetectorRef,
    public transifexService: TransifexService,
    @Inject(MAT_DIALOG_DATA) public reifenData_: ReifenData,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {
    this.appointmentsPopupService.reifenData = reifenData_
    this.setStepper()
  }

  ngOnInit (): void {
    this.setStepper()
    this.setStepperStep()

    this.appointmentsPopupService.sendGTMData(
      this.stepper?.selectedIndex >= 0 ? this.stepper.selectedIndex + 1 : 1
    )

    this.appointmentsPopupService.loading = true
    this.appointmentsPopupService.country =
      this.remoteConfigService.get('country.code')

    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    // we want the button to be disabled from start if we started on higher steps
    if (this.appointmentsPopupService.reifenData?.vehicle != null) {
      this.appointmentsPopupService.loadingCarData = true
    }

    void this.appointmentsPopupService.getDataFromLS()

    this.appointmentsPopupService.loadData()

    this.cdf.detectChanges()
  }

  ngAfterViewInit (): void {
    this.setStepper()
  }

  setStepper (): void {
    // TODO: EFDOG-1057 - _getIndicatorType was a private MatStepper API removed upstream; this override no longer affects indicators.
    // this.stepper._getIndicatorType = () => 'number'
  }

  setStepperStep (): void {
    if (
      this.appointmentsPopupService.reifenData?.vehicle != null &&
      this.appointmentsPopupService.reifenData?.step != null
    ) {
      this.stepper.selectedIndex = this.appointmentsPopupService.reifenData.step
    } else if (
      this.appointmentsPopupService.reifenData?.vehicle != null &&
      this.appointmentsPopupService.reifenData?.step == null
    ) {
      if (
        this.appointmentsPopupService.reifenData.vehicle.currentMileage !=
          null ||
        this.appointmentsPopupService.reifenData.vehicle.manualMileage != null
      ) {
        this.stepper.selectedIndex = 2
        this.appointmentsPopupService.secondFormGroup
          .get('mileage')
          .setValue(
            this.appointmentsPopupService.reifenData.vehicle.manualMileage !=
              null
              ? this.appointmentsPopupService.reifenData.vehicle.manualMileage
              : this.appointmentsPopupService.reifenData.vehicle.currentMileage
          )
      } else {
        this.stepper.selectedIndex = 1
      }
    }
  }

  ngOnDestroy(): void {
    this.sharedService.unsubscribe(this.appointmentsPopupService.sub)
  }

  isServiceAction(): boolean {
    return this.appointmentsPopupService?.reifenData?.serviceAction === true
  }

  onFirstStepNext (): void {
    if (this.appointmentsPopupService.showChooseStepDialog) {
      this.appointmentsPopupService.decideNextStep(this.stepper)
    } else {
      this.stepper.next()
    }
    this.appointmentsPopupService.sendGTMData(2)
    this.appointmentsPopupService.checkSelected()
  }
}
